import {Col, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'

const InformationLayout = () => {
  const navigate = useNavigate()

  return (
    <div
      className='d-flex align-items-center justify-content-between rounded-4 px-15 py-10'
      style={{
        background: 'linear-gradient(90deg, #ff6a00 0%, #ffb400 100%)',
        color: 'white',
      }}
    >
      <Row className='flex-grow-1 align-items-center'>
        <Col md={9}>
          <h4 className='fw-bold mb-2' style={{textTransform: 'none'}}>
            🌟 Jadi Bagian dari Cerita Inspiratif Alumni LPDP!
          </h4>
          <p className='mb-1'>
            Tunjukkan perjalanan, prestasi, dan kontribusi Anda untuk menginspirasi generasi
            berikutnya.
          </p>
          <p className='mb-0 mt-10'>Isi form online & unggah foto Anda.</p>
        </Col>

        <Col md={3} className='text-md-end text-center mt-3 mt-md-0'>
          <button
            className='btn btn-light px-4 py-2 rounded-pill text-primary px-10 py-3 fw-bold'
            onClick={() => navigate('ajukan-profil')}
          >
            <i className='bi bi-person-plus text-primary fs-3'></i> Ajukan Profil Sekarang
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default InformationLayout
